import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import {
  IGetReportsArgs,
  IGetReportsPayload,
  IOtherManagementState
} from '../types';
import otherManagementServices from '../otherManagementServices';

export const getReports = createAsyncThunk<
  IGetReportsPayload,
  IGetReportsArgs | undefined,
  ThunkAPIConfig
>('getReports', async (args, { rejectWithValue }) => {
  try {
    const { data } = await otherManagementServices.getReports({
      page: args?.page || 1,
      limit: args?.limit || 5
    });

    return {
      data: data.data.result,
      pagination: data.data.metaData
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getReportsBuilder = (
  builder: ActionReducerMapBuilder<IOtherManagementState>
) => {
  const { pending, fulfilled, rejected } = getReports;
  builder
    .addCase(pending, draftState => {
      draftState.report.loading = true;
    })
    .addCase(fulfilled, (draftState, action) => {
      draftState.report.loading = false;
      draftState.report.data = action.payload.data;
      draftState.report.pagination = action.payload.pagination;
    })
    .addCase(rejected, draftState => {
      draftState.report.loading = false;
    });
};
